exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1IN0z a{text-decoration:none}._1cFkU,._3O-q1{position:fixed;top:0;bottom:0;left:0;right:0}._1IN0z ._1cFkU .dEGAL{height:100%;width:100%;-o-object-fit:cover;object-fit:cover}._1IN0z ._3O-q1{width:100%;height:100%;position:absolute;top:0;left:0}._3O-q1 ._2eCc0{width:1155px;height:60px;line-height:60px;margin:30px 103px;display:-webkit-box;display:-ms-flexbox;display:flex}._2Sr-G{width:234px;height:59px}._2eCc0 a{font-size:16px;font-family:PingFangSC-Regular,PingFang SC;color:#fff;text-shadow:0 1px 2px rgba(0,0,0,.24);font-weight:500;display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding-top:12px;margin-right:20px}.QnqAg{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;top:50%;right:8%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}._2bSB9{width:392px;height:154px;margin-right:30px;margin-top:21px}.kdzsm{width:190px;height:190px;border-radius:12px;margin-bottom:8px;background:#fff}._23rtp{margin:10px}._3RuAB{font-size:18px;color:hsla(0,0%,100%,.9)}._3giMN,._3RuAB{font-family:PingFangSC-Medium,PingFang SC;font-weight:500;text-align:center}._3giMN{position:absolute;bottom:32px;width:100%;font-size:12px;color:#fff;line-height:17px;text-shadow:0 1px 2px rgba(0,0,0,.1)}._3qDBO{position:fixed;left:-999px;top:-100px;text-indent:-2000px;overflow:hidden}._3giMN a{color:#fff}", ""]);

// exports
exports.locals = {
	"container": "_1IN0z",
	"videoBg": "_1cFkU",
	"content": "_3O-q1",
	"video": "dEGAL",
	"header": "_2eCc0",
	"logo": "_2Sr-G",
	"middle": "QnqAg",
	"slogan": "_2bSB9",
	"qr": "kdzsm",
	"qrcode": "_23rtp",
	"tips": "_3RuAB",
	"footer": "_3giMN",
	"title": "_3qDBO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/download/Download.css
// module id = 1276
// module chunks = 13